'use client'
const validateMfaRecoveryCode = (text) => {
    const regex = /^(\w+\s){23}\w+$/;
    return regex.test(text);
};

export { validateMfaRecoveryCode };
